export class SC_YesNoEnum {
    static readonly NULL = 0;
    static readonly NA = 1;
    static readonly YES = 2;
    static readonly NO = 3;

    constructor(private type: number = SC_YesNoEnum.NULL) { }

    static fromAPI(apiValue: number | string): SC_YesNoEnum {
        switch (Number(apiValue)) {
            case SC_YesNoEnum.YES:
                return new SC_YesNoEnum(SC_YesNoEnum.YES);
            case SC_YesNoEnum.NO:
                return new SC_YesNoEnum(SC_YesNoEnum.NO);
            case SC_YesNoEnum.NA:
                return new SC_YesNoEnum(SC_YesNoEnum.NA);
            default:
                return new SC_YesNoEnum();
        }
    }

    is(type: number): boolean {
        return this.type === type;
    }

    toAPI(): number {
        return this.type;
    }

    clone(): SC_YesNoEnum {
        return new SC_YesNoEnum(this.type);
    }

    merge(other: SC_YesNoEnum): SC_YesNoEnum {
        if (other.type !== SC_YesNoEnum.NULL) {
            this.type = other.type;
        }

        return this;
    }

    static readonly statuses = [
        { key: SC_YesNoEnum.YES, display: "Yes" },
        { key: SC_YesNoEnum.NO, display: "No" },
        { key: SC_YesNoEnum.NA, display: "N/A" },
    ];

    toString(): string {
        switch (this.type) {
            case SC_YesNoEnum.NA:
                return "N/A";
            case SC_YesNoEnum.YES:
                return "YES";
            case SC_YesNoEnum.NO:
                return "NO";
            default:
                return "NULL";
        }
    }
}
